import cn from 'classnames';
import { useRef, useState } from 'react';
import type { CDEKCity } from '@shared/types/delivery';
import useDebounce from 'library/hooks/common/useDebounce';
import * as st from './styles.module.scss';

interface Props {
  citySearch: string;
  onSearchChange: (e: string) => void;
  cities: CDEKCity[];
  selected: CDEKCity;
  onChange: (city: CDEKCity) => void;
  error: any;
  setCity: (city: CDEKCity) => void;
}

export const CitySelect = ({
  citySearch,
  onSearchChange,
  cities,
  selected,
  onChange,
  error,
  setCity,
}: Props) => {
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedInput = useDebounce((value) => onSearchChange(value), citySearch);

  const handleSelect = (city: CDEKCity) => {
    onChange(city);
    setShowSearch(false);
    setCity(city);
  };

  const handleShowSearch = () => {
    setShowSearch(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 200);
  };
  // const handleFullSelected = (value: any): string => {
  // 	const city: string = value.title !== '<None>' ? value.title : '';
  //
  // 	const region: string =
  // 		value.region.title && value.region.title !== '<None>' && value.region.title !== value.title
  // 			? `, ${value.region.title}`
  // 			: '';
  // 	const subRegion: string =
  // 		value.sub_region &&
  // 		value.sub_region !== '<None>' &&
  // 		value.sub_region !== value.region.title &&
  // 		value.sub_region !== value.title
  // 			? `, ${value.sub_region}`
  // 			: '';
  // 	return `${city && city}${region && region}${subRegion && subRegion}`;
  // };

  return (
    <div className={cn(st.search, error && st.error)}>
      <label htmlFor="city" className={st.label}>
        Город
      </label>

      {showSearch ? (
        <>
          <input
            className={st.input}
            type="text"
            id="city"
            placeholder="Выберите город получателя"
            value={debouncedInput.value}
            onChange={(e) => debouncedInput.handleChange(e.target.value)}
            onBlur={() => setShowSearch(false)}
            autoComplete="new-password"
            ref={inputRef}
          />
        </>
      ) : (
        <button className={st.button} type="button" onClick={() => handleShowSearch()}>
          {selected.city_uuid ? selected.full_name : 'Выберите город получателя'}
        </button>
      )}

      <ul className={cn(st.list, !showSearch && st.hidden)}>
        {cities.map((city) => (
          <li key={city.city_uuid} onMouseDown={() => handleSelect(city)}>
            {city.full_name}
          </li>
        ))}
      </ul>
    </div>
  );
};
